import { apiClient } from '@src/services/http-common'
import { PersonWeeklyPresencesDto } from '@src/types/Dto/Home'
import { useQuery } from '@tanstack/react-query'

const PRESENCE_SCOPE = 'Presences'
const LIST = 'list'

const keysFactory = {
  getAllWeeklyPresences: (year: string) => [PRESENCE_SCOPE, LIST, year] as const,
}

async function getAllWeeklyPresences(year: string) {
  const response = await apiClient.get<PersonWeeklyPresencesDto[]>(`/WeeklyPresences/${year}`)
  return response.data
}

export function useGetAllWeeklyPresences(year: string): [PersonWeeklyPresencesDto[] | null, boolean] {
  const { isFetching, data } = useQuery({
    queryFn: () => getAllWeeklyPresences(year),
    queryKey: keysFactory.getAllWeeklyPresences(year),
  })

  return [data ?? null, isFetching]
}
